import React from 'react';
import Select from 'react-select';

const CreateDepartment = () => {
	return (
		<div className="popup-wrapper">
			<div className="common-popup create-department-popup">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-14 mb-0">Create department</h3>
					</div>
					<div className="close-btn">
						<img src="/icons/close.svg" alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="create-department-table">
						<table className="table height-sm hover with-border">
							<thead>
								<tr>
									<th>Market</th>
									<th>Fabric</th>
									<th>Category</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="market-column">
										<Select
											className="no-shadow-react-select"
											isMulti
											value={'TEST'}
											onChange={() => {}}
											options={[
												{ label: '01', value: 'Test', id: 1 },
												{ label: '02', value: 'Test1', id: 2 },
												{ label: '03', value: 'Test2', id: 3 }
											]}
											isClearable
										/>
									</td>
									<td className="fabric-column">
										<Select
											className="no-shadow-react-select"
											isMulti
											value={'TEST'}
											onChange={() => {}}
											options={[
												{ label: '01', value: 'Test', id: 1 },
												{ label: '02', value: 'Test1', id: 2 },
												{ label: '03', value: 'Test2', id: 3 }
											]}
											isClearable
										/>
									</td>
									<td className="category-column">
										<Select
											className="no-shadow-react-select"
											isMulti
											value={'TEST'}
											onChange={() => {}}
											options={[
												{ label: '01', value: 'Test', id: 1 },
												{ label: '02', value: 'Test1', id: 2 },
												{ label: '03', value: 'Test2', id: 3 }
											]}
											isClearable
										/>
									</td>
									<td>
										<div className="option action-column">
											<div className="dropdown">
												<button
													className="btn btn-default dropdown-toggle"
													type="button"
													id="menu1"
													data-toggle="dropdown"
													aria-expanded="false"
												>
													<img src="/icons/more_icon.svg" alt="" />
												</button>
												<ul
													className="dropdown-menu dropdown-menu-right shadow-lg"
													role="menu"
													aria-labelledby="menu1"
													x-placement="bottom-end"
												>
													<li role="presentation" className="px-4 pb-3 pt-3">
														<a
															role="menuitem"
															tabIndex={-1}
															className="font-weight-normal  text-black"
															href="/invoices/edit/10052"
														>
															Edit
														</a>
													</li>
													<li role="presentation" className="px-4 pb-3">
														<a
															role="menuitem"
															tabIndex={-1}
															className="font-weight-normal  text-black"
															href
														>
															Delete
														</a>
													</li>
												</ul>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateDepartment;
